import React, { useState, useEffect } from 'react';
import PublicationsListAdmin from './PublicationsListAdmin.jsx';
import PublicationModalForm from './PublicationModalForm.jsx';
import Modal from '../../pages/util/admin/Modal.jsx';

// Container for admin publications management
export default function PublicationAdminPanel({
  fetchPublications,
  uploadPublication,
  updatePublication,
  deletePublication,
  publications,
  loading,
  error,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('upload'); // 'upload' or 'edit'
  const [selectedPub, setSelectedPub] = useState(null);
  const [formError, setFormError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState({ open: false, pub: null });

  useEffect(() => {
    fetchPublications && fetchPublications();
    // eslint-disable-next-line
  }, []);

  const handleEdit = (pub) => {
    setSelectedPub(pub);
    setModalMode('edit');
    setModalOpen(true);
    setFormError(null);
  };

  const handleUpload = () => {
    setSelectedPub(null);
    setModalMode('upload');
    setModalOpen(true);
    setFormError(null);
  };

  const handleDelete = (pub) => {
    setConfirmDelete({ open: true, pub });
  };

  const handleConfirmDelete = async () => {
    if (confirmDelete.pub) {
      await deletePublication(confirmDelete.pub);
      fetchPublications && fetchPublications();
    }
    setConfirmDelete({ open: false, pub: null });
  };

  const handleCancelDelete = () => {
    setConfirmDelete({ open: false, pub: null });
  };

  const handleModalSubmit = async (values) => {
    setUploading(true);
    setFormError(null);
    try {
      if (modalMode === 'edit' && selectedPub && values.file === null) {
        await updatePublication(selectedPub, values);
      } else {
        await uploadPublication(values);
      }
      setModalOpen(false);
      fetchPublications && fetchPublications();
    } catch (err) {
      setFormError(err.message || 'Failed to save publication');
    } finally {
      setUploading(false);
    }
  };

  return (
    <>
      <div className="users-header">
        <h3>Publications</h3>
        <button onClick={handleUpload} className="btn btn-primary">Upload Publication</button>
      </div>
      <PublicationsListAdmin
        publications={publications}
        loading={loading}
        error={error}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />
      <PublicationModalForm
        open={modalOpen}
        mode={modalMode}
        initialValues={modalMode === 'edit' && selectedPub ? {
          ...selectedPub.metadata,
          publishDate: selectedPub.metadata?.publishdate || '',
          file: null,
        } : {}}
        onSubmit={handleModalSubmit}
        onClose={() => setModalOpen(false)}
        uploading={uploading}
        error={formError}
      />
      <Modal open={confirmDelete.open} onClose={handleCancelDelete}>
        <h3>Confirm Delete</h3>
        <p>Are you sure you want to delete publication <b>{confirmDelete.pub?.name}</b>?</p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 24 }}>
          <button onClick={handleCancelDelete} className="button-default">Cancel</button>
          <button onClick={handleConfirmDelete} className="button-danger">Delete</button>
        </div>
      </Modal>
    </>
  );
}
